import { cn } from "@/lib/utils";

interface Step {
	number: number;
	label: string;
}

export function StepIndicator({
	steps,
	current,
	onStepClick,
}: {
	steps: Step[];
	current: number;
	onStepClick?: (step: number) => void;
}) {
	return (
		<ol
			className="mb-6 flex items-center justify-center gap-2 text-sm md:gap-4"
			aria-label="Progress"
		>
			{steps.map((step) => {
				const isActive = step.number === current;
				const isCompleted = step.number < current;
				return (
					<li
						key={step.number}
						aria-current={isActive ? "step" : undefined}
						className={cn(
							"flex items-center gap-2 rounded-full px-3 py-1 transition-all",
							isActive
								? "bg-primary font-semibold text-primary-foreground"
								: "bg-muted text-muted-foreground",
							(onStepClick || isCompleted) && "cursor-pointer hover:bg-primary/10",
						)}
						onClick={() => onStepClick?.(step.number)}
					>
						<span
							className={cn(
								"inline-flex h-5 w-5 items-center justify-center rounded-full text-xs",
								isActive || isCompleted
									? "bg-primary/20"
									: "bg-muted-foreground/20",
							)}
						>
							{step.number}
						</span>
						<span className="hidden md:inline">{step.label}</span>
					</li>
				);
			})}
		</ol>
	);
}
